import fetcher from 'api/fetcher';

import {
    Balance,
    BalanceHistory,
    BalanceStatistic,
    BonusHistory,
    setBalance,
    setBalanceHistory,
    setBalanceStatistic,
    setBonusHistory,
} from 'store/models/balance';
import { AppThunkAction } from 'store/utils';

interface BonusHistoryResponse {
    bonuses: BonusHistory;
}

interface BalanceHistoryResponse {
    transactions: BalanceHistory;
}

export const fetchBalanceAndBonuses = (): AppThunkAction => {
    return async (dispatch) => {
        try {
            const [balance, bonusHistory, balanceHistory, balanceStatistic] = await Promise.all([
                fetcher.get<unknown, Balance>('/api/v1/account/balance'),
                fetcher.get<unknown, BonusHistoryResponse>('/api/v1/account/balance/bonus'),
                fetcher.get<unknown, BalanceHistoryResponse>('/api/v1/account/balance/history/year'),
                fetcher.get<unknown, BalanceStatistic>('/api/v1/account/balance/statistic/short'),
            ]);

            dispatch([
                setBalance(balance),
                setBonusHistory(bonusHistory.bonuses),
                setBalanceHistory(balanceHistory.transactions),
                setBalanceStatistic(balanceStatistic),
            ]);
        } catch (error) {
            console.error('Failed to fetch bonuses data:', error);
        }
    };
};
